export default __webpack_public_path__ + "static/media/infitess.82e69b8c.png";